let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4gWkt")).then(() => parcelRequire('mEhhU'));